var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('r-badge',{attrs:{"type":_vm.badgeType}},[_vm._v(_vm._s(_vm._f("unKebabCase")(this.creditMemo.status)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }